import React from "react";
import IoIosPeople from "react-icons/lib/io/ios-people";
import withAuth from "shared/Auth/withAuth/withAuth";
import Logo from "shared/Experimental/General/components/Logo/Logo";
import {SkipNavLink} from "@unibuddy/patron";
import NavLink from "./NavLink/NavLink";
import PrivateNavigation from "./PrivateNavigation";
import s from "./Navigation.pcss";

const Navigation = ({authState, university}) => {
    const isAuthenticated = authState.token && authState.me;

    return (
        <nav className={s.navigation} data-test-id="navbar">
            <SkipNavLink contentId={"content"} />
            <Logo className={s.logo} width={90} />
            {isAuthenticated ? (
                <PrivateNavigation me={authState.me} university={university} />
            ) : (
                <NavLink to="/auth/login">
                    <IoIosPeople /> <span>Login</span>
                </NavLink>
            )}
        </nav>
    );
};

export default withAuth(Navigation);
